"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _throttle = _interopRequireDefault(require("lodash/throttle"));
var _dom = require("../dom");
var _customHooks = require("../custom-hooks");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* istanbul ignore next */
const nearest = (best, item) => item.scroll > best.scroll && item.scroll <= window.scrollY + 10 ? item : best;

/**
 * Find Best Match section while scrolling
 */
const spyScroll = elements => {
  // create an Object with all children that has data-id attribute
  const bestMatch = elements
  // compute `item.scroll`
  ?.map(item => ({
    scroll: (0, _dom.getOffsetTop)(item.elem) - (0, _dom.getScrollMarginTop)(item.elem),
    id: item.id
  }))
  // return the item with the smallest delta
  .reduce(nearest);
  return bestMatch?.id;
};

/**
 * pass current section to component and add listener while scroll
 */
const ScrollSection = _ref => {
  let {
    sectionsWrapperRef,
    scrollspyRef,
    children
  } = _ref;
  const [currentSection, setCurrentSection] = (0, _react.useState)();
  const [targetElements, setTargetElements] = (0, _react.useState)(null);
  const size = (0, _customHooks.useWindowSize)();
  const [isVisible, setIsVisible] = (0, _react.useState)(false);

  // Enforces a maximum number of time setCurrentSection can be called, at most once every 100 milliseconds
  const throttledOnScroll = (0, _throttle.default)(elements => {
    /* istanbul ignore next line */
    setCurrentSection(spyScroll(elements));
  }, 100);

  /* istanbul ignore next */
  const scrollCallback = (0, _react.useCallback)(() => {
    throttledOnScroll(targetElements);
    if (size.width >= 768 && scrollspyRef.current) return;
    let heightToHideFrom = (0, _dom.getOffsetTop)(scrollspyRef.current);
    const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    if (winScroll > heightToHideFrom) {
      setIsVisible(true);
    } else {
      isVisible && setIsVisible(false);
    }
  }, [isVisible, scrollspyRef, size, targetElements]);

  // We don't have specific tests for mobile only. As this targets visibility on mobile only screens, there's currently no good way to test.
  /* istanbul ignore next */
  const findScroll = element => {
    if (!element) return;
    element.onscroll = scrollCallback;
    findScroll(element.parentNode);
  };

  // scroll div could be anywhere on the application we will need
  //to find the component and place an onScrolling event on it
  findScroll(sectionsWrapperRef?.current);
  (0, _react.useEffect)(() => {
    const tElements = [...sectionsWrapperRef?.current?.children]?.map(item => ({
      id: item?.dataset?.id,
      elem: item
    }));
    setTargetElements(tElements);
  }, [sectionsWrapperRef]);
  (0, _react.useEffect)(() => {
    setCurrentSection(spyScroll(targetElements));
  }, [throttledOnScroll, sectionsWrapperRef, targetElements]);
  return children(currentSection, isVisible, scrollspyRef);
};
ScrollSection.propTypes = {
  children: _propTypes.default.func.isRequired,
  scrollspyRef: _propTypes.default.object.isRequired,
  sectionsWrapperRef: _propTypes.default.object.isRequired
};
var _default = exports.default = ScrollSection;